import { split, toLower } from "no-case";
export function paramCase(input, options) {
    const lower = toLower(options?.locale);
    return split(input, options).map(lower).join("-");
}
//# sourceMappingURL=index.js.map